import { Injectable, inject } from '@angular/core';

import { HttpService } from '@shared/services';
import { PresetDocument } from './api-models/entity-templates.model';

type EntityTemplateRequestParams = {
  id: number;
  moduleId: number;
};

@Injectable({
  providedIn: 'root',
})
export class EntityTemplatesService {
  private http = inject(HttpService);

  getPresetDocumentDetails({ id, moduleId }: Pick<EntityTemplateRequestParams, 'id' | 'moduleId'>) {
    const params = this.http.buildHttpParams({ id });
    return this.http.get<PresetDocument>('_api/EntityTemplates/Get', {
      httpOptions: {
        params,
        headers: { moduleId: moduleId.toString() },
      },
    });
  }
}
